import Link from 'next/link';
import { NavbarBrand } from 'react-bootstrap';
import clsx from 'clsx';

const LogoBox = ({ imgClassName, onlyDark }) => {
  const logoStyle = { height: 'clamp(38px, 3.8vw, 50px)' };

  return (
    <NavbarBrand as={Link} href="/" className="text-decoration-none">
      <span
        className={clsx('southcrete-logo navbar-brand-item', !onlyDark && 'light-mode-item', imgClassName)}
        style={logoStyle}
        role="img"
        aria-label="South Crete"
      />
    </NavbarBrand>
  );
};
export default LogoBox;
